import React from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS;

type Props = {
    open: boolean;
    onClose: () => void;
};

export const ConfirmInteractionModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();

    return (
        <ConfirmModal
            open={open}
            maxWidth='sm'
            title={t(T_KEYS.COMPONENTS.CONFIRM_INTERACTION_MODAL.TITLE)}
            content={t(T_KEYS.COMPONENTS.CONFIRM_INTERACTION_MODAL.MESSAGE)}
            okText={t(T_KEYS.COMMON.BUTTONS.CONTINUE)}
            hideCancelButton
            onClose={onClose}
        />
    );
};